import React, { useEffect, useState } from "react";
import "../../App.css";
import LOGO from "../../assets/images/logogc.png";
import { BiBriefcase } from "react-icons/bi";
import { useTranslation } from "react-i18next";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  TeamOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Card, Col, Layout, Menu, Row } from "antd";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Logout from "../../component/logout/Logout";
import LanguageModel from "../../component/languageModel/LanguageModel";
import { API_URL } from "../../helper/Helper";
const { Header, Sider, Content } = Layout;

//icon

const Dashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [logOutModal, setLogOutModal] = useState(false);
  const [languageModal, setLanguageModal] = useState(false);
  const { t } = useTranslation();

  const [token, setToken] = useState(
    localStorage.getItem("token") ? localStorage.getItem("token") : null
  );
  const [language, setLanguage] = useState(
    localStorage.getItem("language") ? localStorage.getItem("language") : null
  );

  const [countryName, setcountryName] = useState(
    JSON.parse(localStorage.getItem("userdata")).data.country
  );

  const [totalData, setTotalData] = useState({
    club: "",
    member: "",
    work: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
    if (!language) {
      setLanguageModal(true);
    }
  }, []);

  useEffect(() => {
    getTotal();
  }, []);

  const getTotal = () => {
    fetch(`${API_URL}/api/countryadmin/getTotalCAWorkMember/${countryName}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      method: "GET",
    })
      .then((res) => {
        return res.json();
      })
      .then((e) => {
        e.data.map((item) => {
          setTotalData({
            club: item.clubs,
            member: item.members,
            work: item.works,
          });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onClickLogOutModal = () => {
    setLogOutModal(true);
  };

  return (
    <Layout style={{ height: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        theme="light"
        style={{ position: "sticky", height: "100vh", top: "0" }}
      >
        <div className="logo">
          {/* <p className="logoText">GC</p> */}
          <img src={LOGO} height={30} width={30} className="logoText" />
        </div>
        <Menu
          style={{ padding: "24px 0px" }}
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={[
            {
              key: "1",
              icon: <DashboardOutlined />,
              label: <Link to="/dashboard">{t("Dashboard")}</Link>,
            },
            {
              key: "2",
              icon: <TeamOutlined />,
              label: <Link to="/club">{t("Club")}</Link>,
            },
            {
              key: "3",
              icon: <UserOutlined />,
              label: <Link to="/member">{t("Member")}</Link>,
            },
            {
              key: "5",
              icon: <BiBriefcase style={{ fontSize: "18px" }} />,
              label: <Link to="/work">{t("Work")}</Link>,
            },
            {
              key: "6",
              icon: <BiBriefcase style={{ fontSize: "18px" }} />,
              label: <Link to="/allwork">{t("All Work")}</Link>,
            },
            {
              key: "4",
              icon: <LogoutOutlined />,
              label: (
                <a href="javascript:void(0)" onClick={onClickLogOutModal}>
                  {t("Logout")}
                </a>
              ),
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: "0px 20px",
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
        </Header>
        <Content className="main-content">
          <Breadcrumb
            style={{
              margin: "16px 0",
            }}
          >
            <Breadcrumb.Item>
              <DashboardOutlined />
              &nbsp;{t("Dashboard")}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-card-wrapper">
            <Row gutter={24}>
              <Col lg={6} md={12} sm={12}>
                <Card
                  hoverable
                  bordered={false}
                  style={{ marginTop: "10px", padding: "10px" }}
                >
                  <Link to="/club">
                    <div style={{ display: "flex" }}>
                      <div>
                        {" "}
                        <UserOutlined style={{ fontSize: "54px" }} />
                      </div>
                      <div style={{ marginLeft: "15px", color: "#929292d9" }}>
                        <h2 style={{ color: "#929292d9" }}>{t("Club")}</h2>
                        <p className="text-overflow-p">{totalData.club}</p>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Col>
              <Col lg={6} md={12} sm={12}>
                <Card
                  hoverable
                  bordered={false}
                  style={{ marginTop: "10px", padding: "10px" }}
                >
                  <Link to="/member">
                    <div style={{ display: "flex" }}>
                      <div>
                        <TeamOutlined style={{ fontSize: "54px" }} />
                      </div>
                      <div style={{ marginLeft: "15px", color: "#929292d9" }}>
                        <h2 style={{ color: "#929292d9" }}>{t("Member")}</h2>
                        <p className="text-overflow-p">{totalData.member}</p>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Col>
              <Col lg={6} md={12} sm={12}>
                <Card
                  hoverable
                  bordered={false}
                  style={{ marginTop: "10px", padding: "10px" }}
                >
                  <Link to="/work">
                    <div style={{ display: "flex" }}>
                      <div>
                        <BiBriefcase style={{ fontSize: "50px" }} />
                      </div>
                      <div style={{ marginLeft: "15px", color: "#929292d9" }}>
                        <h2 style={{ color: "#929292d9" }}>{t("Work")}</h2>
                        <p className="text-overflow-p">{totalData.work}</p>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Col>

              {/* <Col lg={6} md={12} sm={12}>
                <Card
                  hoverable
                  bordered={false}
                  style={{ marginTop: "10px", padding: "10px" }}
                >
                  <Link to="/countryadmin">
                    <div style={{ display: "flex" }}>
                      <div>
                        <BiBriefcase style={{ fontSize: "50px" }} />
                      </div>
                      <div style={{ marginLeft: "15px", color: "#929292d9" }}>
                        <h2 style={{ color: "#929292d9" }}>{t("Country Admin")}</h2>
                        <p className="text-overflow-p">{totalData.work}</p>
                      </div>
                    </div>
                  </Link>
                </Card>
              </Col> */}
            </Row>
          </div>
        </Content>
      </Layout>
      <Logout
        visibleLogOutModal={logOutModal}
        onClickLogOutModelCancel={() => setLogOutModal(false)}
      />
      <LanguageModel
        visibleLanguageModel={languageModal}
        onClickLanguageModelCancel={() => setLanguageModal(false)}
      />
    </Layout>
  );
};

export default Dashboard;
